import { useGetTeamsQuery } from "../../features/api/apiSlice";

const TeamMembers = () => {
  const { data: teams, isLoading, isError, error } = useGetTeamsQuery();

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (!isLoading && isError) {
    content = <p>{error?.data}</p>;
  } else if (!isLoading && !isError && teams?.length === 0) {
    content = <p>No Team Members found!</p>;
  } else if (!isLoading && !isError && teams?.length > 0) {
    content = teams.map((team) => (
      <div className="checkbox-container" key={team.id}>
        <img src={team.avatar} className="team-avater" alt={team.name} />
        <p className="label">{team.name}</p>
      </div>
    ));
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default TeamMembers;
